import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
  },
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  progress: {
    color: '#F0A31C', // Konteks gold color
  },
}));

export const KonteksProgress = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.progressContainer}>
        <CircularProgress
          className={classes.progress}
          size={48}
          thickness={4}
        />
      </Box>
    </Box>
  );
};

export default KonteksProgress;
